import { render, staticRenderFns } from "./DocumentContainer.vue?vue&type=template&id=a65ef0e8&scoped=true"
import script from "./DocumentContainer.vue?vue&type=script&lang=js"
export * from "./DocumentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65ef0e8",
  null
  
)

export default component.exports